/**
 * @generated SignedSource<<6356962d5151500ffe644b13f3f244e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItems_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItems_viewer" | "NavItem_viewer">;
  readonly " $fragmentType": "NavItems_viewer";
};
export type NavItems_viewer$key = {
  readonly " $data"?: NavItems_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItems_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItems_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavExpandingAreaItems_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "25ebdec5e9b22b97a2a03dcd9814d99e";

export default node;
